import $api from "@/frontend/shared/api/axios";
import { TOrganizationDetails } from "@/frontend/pages/SettingsPage/model/types/types";

export async function getOrganizationById(id: number): Promise<TOrganizationDetails> {
  const response = await $api.get(`/organizations/${id}`);
  return response.data.data;
}
